module.exports = __webpack_public_path__ + "fonts/karla-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Karla/karla-regular-webfont.woff
// module id = 3429
// module chunks = 0